"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledCardHeader = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
//
// properties
//
const config_1 = require("assets/styles/config");
exports.StyledCardHeader = styled_components_1.default.div `
  border-bottom: ${({ top }) => top ? `1px solid ${config_1.colors.pavement}` : 'none'}};
  height: ${({ height }) => (height ? height : '80px')}};
  padding: ${({ padding }) => (padding ? padding : '12px 20px')}};
`;
